import { i18n } from '@/plugins/i18n'
import { shRequestStatusStr } from '@/constants/shaparakRequestStatus'
import { shRequestVariant } from '@/constants/shaparakRequestStatus'
import RejectionReasonsColumn from "../components/rejection-reasons";
import { shRequestStatus } from '@/constants/shaparakRequestStatus'
import createdRequestcolumn from "../components/created-request-columns2"
import store from '@/store'
import { shRequestType } from '@/constants/shaparakRequestType';
import changeStakeholdersRequestColumn from '../components/change-stakeholders-request-column';

const rejectionReasonTemplate = (row, index, datatable) => {
    let template = new RejectionReasonsColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

const createdRequestTemplate = (row, index, datatable) => {
    let template = new createdRequestcolumn({
        props: {
            row,
            index,
            datatable,
            store
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable
    template.store = store

    return template.$mount().$el
}

const changeStakeholdersRequestTemplate = (row, index, datatable) => {
    let template = new changeStakeholdersRequestColumn({
        props: {
            row,
            index,
            datatable,
            store,
        },
        i18n,
    });

    template.row = row;
    template.index = index;
    template.datatable = datatable;
    template.store = store;

    return template.$mount().$el;
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 65,
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'gateway_title',
        title: i18n.t('shaparakRequests.gateway_title'),
        template: (row) => {
            return '<a href="/gateway/gateway-pf/' + row.gateway_id + '/details">'+row.gateway_title+'</a>'
        },
        sortable: false,
        width: 100,
        textAlign: 'center',
    },
    {
        field: 'request_type',
        title: i18n.t('shaparakRequests.request_type'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'psp',
        title: i18n.t('label.psp'),
        sortable: false,
        textAlign: 'center',
        width: 70,
        template: (row) => {
            switch(row.psp) {
                case 'mellat':
                    return '<div><img src="/assets/media/psp/mellat.png" width="32" height="32"></div>';
                case 'parsian':
                    return '<div><img src="/assets/media/psp/parsian.svg" width="32" height="32"></div>';
                case 'pasargad':
                    return '<div><img src="/assets/media/psp/pasargad.svg" width="32" height="32"></div>';
                case 'saman':
                    return '<div><img src="/assets/media/psp/saman.svg" width="32" height="32"></div>';
                case 'novin':
                    return '<div><img src="/assets/media/psp/novin.svg" width="32" height="32"></div>';
                case 'sepehr':
                    return '<div><img src="/assets/media/psp/sepehr.png" width="32" height="32"></div>';
                case 'irankish':
                    return '<div><img src="/assets/media/psp/irankish.png" width="32" height="32"></div>';
                case 'asanpardakht':
                    return '<div><img src="/assets/media/psp/ap-logo.png" width="32" height="32"></div>';
            }
            return '<span>' + row.psp + '</span>';
        },
    },
    {
        field: 'status',
        title: i18n.t('shaparakRequests.status'),
        textAlign: 'center',
        template: (row) => {
            let status  = shRequestStatusStr.get(row.status)
            let variant = 'badge-'+shRequestVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        sortable: true,
        width: 80,
    },
    {
        field: 'tracking_number',
        title: i18n.t('shaparakRequests.tracking_number'),
        width: 110,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('shaparakRequests.created_at'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'rejection_reason',
        title: i18n.t('shaparakRequests.description'),
        sortable: false,
        width: 80,
        template: (row, index, datatable) => {
            if (row.status === shRequestStatus.CREATED) {
                if (row.request_type_code == shRequestType.EDIT_INFO) {
                    return changeStakeholdersRequestTemplate(row, index, datatable);
                }
                if (row.request_type_code == shRequestType.CHANGE_TERMINAL_SHEBA) {
                    return createdRequestTemplate(row, index, datatable);
                }

            }
            return rejectionReasonTemplate(row, index, datatable);
        },
        textAlign: 'center',
    },
]
